import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { GET_PASSAGE_PLANS } from '../graphql/queries';
import ShipCard from './ShipCard';
import LoadingSpinner from './LoadingSpinner';
import ErrorMessage from './ErrorMessage';
import DateFilter from './DateFilter';
import './PassagePlanSearch.css';

const PassagePlanSearch = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedDirection, setSelectedDirection] = useState('all'); // 'all', 'north', 'south'
  const navigate = useNavigate();

  const queryVariables = {
    startAt: startDate || null,
    endAt: endDate || null,
  };

  const { loading, error, data, refetch } = useQuery(GET_PASSAGE_PLANS, {
    variables: queryVariables,
    pollInterval: 30000, // 30秒ごとに自動更新
  });

  const handleDateFilter = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  const handleRefresh = () => {
    refetch();
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage error={error} />;

  const allPassagePlans = data?.getPassagePlans?.passagePlans || [];
  const lastUpdated = data?.getPassagePlans?.lastUpdatedAt;
  const fetchedAt = data?.getPassagePlans?.fetchedAt;

  // 方向でフィルタリング
  const passagePlans = selectedDirection === 'all'
    ? allPassagePlans
    : allPassagePlans.filter(plan => plan.direction === selectedDirection);

  return (
    <div className="passage-plan-search">
      <div className="passage-plan-search-header">
        <button
          className="back-button"
          onClick={() => navigate('/')}
        >
          ← 一覧に戻る
        </button>
        <h2>航行情報検索</h2>
        <div className="passage-plan-search-controls">
          <button
            className="refresh-button"
            onClick={handleRefresh}
            disabled={loading}
          >
            🔄 更新
          </button>
        </div>
      </div>

      <div className="date-filter-section">
        <DateFilter onFilter={handleDateFilter} />
      </div>

      <div className="direction-tabs">
        <button
          className={`direction-tab ${selectedDirection === 'all' ? 'active' : ''}`}
          onClick={() => setSelectedDirection('all')}
        >
          全て
        </button>
        <button
          className={`direction-tab ${selectedDirection === 'north' ? 'active' : ''}`}
          onClick={() => setSelectedDirection('north')}
        >
          北航船
        </button>
        <button
          className={`direction-tab ${selectedDirection === 'south' ? 'active' : ''}`}
          onClick={() => setSelectedDirection('south')}
        >
          南航船
        </button>
      </div>

      {(lastUpdated || fetchedAt) && (
        <div className="update-info">
          {lastUpdated && (
            <p>
              更新: {new Date(lastUpdated).toLocaleString('ja-JP')}
            </p>
          )}
          {fetchedAt && (
            <p>
              取得: {new Date(fetchedAt).toLocaleString('ja-JP')}
            </p>
          )}
        </div>
      )}

      <div className="ship-grid">
        {passagePlans.length === 0 ? (
          <div className="no-data">
            <p>該当する航行情報がありません</p>
          </div>
        ) : (
          passagePlans.map((passagePlan) => (
            <ShipCard key={passagePlan.id} passagePlan={passagePlan} />
          ))
        )}
      </div>
    </div>
  );
};

export default PassagePlanSearch;
